import React from 'react'
import Header from './Header'
import PageTitle from '../Components/PageTitle'
import Footer from './Footer'
const Policy = () => {
  return (
    <>
     <Header />
    
        <PageTitle 
        title=""
        description=""
        keywords=""
        url="/terms" 
        />
    
    
        Policy
        
        <Footer />
    
    
    </>
  )
}

export default Policy